import { useEffect, useRef } from "react";

/**
 * https://github.com/alibaba/hooks
 * https://ahooks.js.org/hooks/use-update-effect
 */
type EffectHookType = typeof useEffect;

const createUpdateEffect: (hook: EffectHookType) => EffectHookType =
  (hook) => (effect, deps) => {
    const isMounted = useRef(false);

    // for react-refresh
    hook(() => {
      return () => {
        isMounted.current = false;
      };
    }, []);

    hook(() => {
      if (!isMounted.current) {
        isMounted.current = true;
      } else {
        return effect();
      }
    }, deps);
  };

const useUpdateEffect = createUpdateEffect(useEffect);

export default useUpdateEffect;
